import {
  Heading,
  Card,
  CardBody,
  Container,
  CardHeader
} from "@chakra-ui/react";
import MyBreadcrumb from "components/breadcrumb/Breadcrumb";
import TargetListCard from "./components/targetListCard/TargetFilter";
import { useSelector } from "react-redux";
import { Breadcrumb } from "types/Breadcrumb";

interface TargetListProps {
}

export default function TargetList({ }: TargetListProps) {

  const selectedDocumentId = useSelector((state: any) => state.documents.selectedDocumentId);
  const targets = useSelector((state: any) => state.documents.documents.find((doc: any) => doc._id === selectedDocumentId)?.targets);
  const breadcrumb: Breadcrumb = new Breadcrumb(
    [
      { label: "Obiettivi", link: "/targets", value: "", isActive: true },
    ]
  );
  
  return (
    <>
      <section className="dashboard-first-section">
        <Container maxW="container.lg" minH={"container.xl"}>
          <MyBreadcrumb breadcrumb={breadcrumb} />


          <Card>
            <CardHeader>
              <Heading as="h1" size="3xl" textAlign={"left"}>
                Lista obiettivi
              </Heading>
            </CardHeader>
            <CardBody>
              {targets?.map((target: any, index: any) => {
                return <TargetListCard is_active={true} target={target} index={index} />;
              })}
            </CardBody>
          </Card>
        </Container>
      </section>
    </>
  );
}
